import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "./item_list";

const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));
